import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

const TestCard = ({ test, index, score, handleScoreChange }) => {
  return (
    <Card className="bg-transparent border-white/20">
      <CardHeader>
        <CardTitle className="text-white">
          {index + 1}. {test.name}
        </CardTitle>
        <p className="text-white/80 text-sm">{test.description}</p>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <Label className="text-white font-medium">Pontuação:</Label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {test.scores.map((scoreDesc, scoreIndex) => (
              <div key={scoreIndex} className="flex items-center space-x-2 p-2 rounded-md hover:bg-white/10 transition-colors">
                <Checkbox
                  id={`${test.id}-${scoreIndex}`}
                  checked={score === scoreIndex}
                  onCheckedChange={(checked) => {
                    if (checked) {
                      handleScoreChange(test.id, scoreIndex);
                    }
                  }}
                  className="border-white/30"
                />
                <Label
                  htmlFor={`${test.id}-${scoreIndex}`}
                  className="text-white/90 text-sm cursor-pointer"
                >
                  {scoreIndex} – {scoreDesc}
                </Label>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TestCard;